import { render, staticRenderFns } from "./spaceOverview.vue?vue&type=template&id=73822f46&scoped=true&"
import script from "./spaceOverview.vue?vue&type=script&lang=js&"
export * from "./spaceOverview.vue?vue&type=script&lang=js&"
import style0 from "./spaceOverview.vue?vue&type=style&index=0&id=73822f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73822f46",
  null
  
)

export default component.exports